__turbopack_context__.v({
  "handle": "drawer-handle-module-scss-module__a0TJFG__handle",
});
